import {
  PlatformPreferenceData,
  PlatformUser,
  SaaSPreferenceData,
  SaaSUser,
} from '@scaleup/models';
import { isNil } from 'lodash';
import { useGetUserQuery, useUpdateUserPreferencesMutation } from '../api';

type Preferences = SaaSPreferenceData & PlatformPreferenceData;

export type UseUserPreference = {
  preference: boolean;
  updateUserPreference: (val: boolean) => Promise<void>;
  updateLoading: boolean;
  preferenceLoading: boolean;
  user?: SaaSUser | PlatformUser;
};

export const useUserPreference = (
  pref: keyof Preferences,
  defaultValue: boolean
): UseUserPreference => {
  const { data: user, isLoading: preferenceLoading } = useGetUserQuery();

  const [updateUserPreferences_, { isLoading: updateLoading }] =
    useUpdateUserPreferencesMutation();

  const updateUserPreference = async (val: boolean) => {
    const prefs = { ...(user?.preferences || {}) }; // creating a new object by spreading
    // @ts-ignore
    prefs[pref] = val;
    await updateUserPreferences_(prefs);
  };

  const getPreference = () => {
    if (!user) {
      return defaultValue;
    }

    const prefs = user.preferences || {};

    // @ts-ignore
    const value = prefs[pref];

    return isNil(value) ? defaultValue : value;
  };

  return {
    preference: getPreference(),
    updateUserPreference,
    updateLoading,
    preferenceLoading,
    user,
  };
};
